import {
  Activate_Payment_Method,
  OfferFragment,
  Payment_Method_Evaluation_Method,
} from '@occc/graphql';
import { makeCreatePaymentMethodConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';

import { PaymentMethodFormValues } from './types';
import {
  getPaymentInstrumentConstraintOperations,
  getPaymentInstrumentsInitialValues,
} from './payment-instrument/utils';

export const getPaymentMethodConstraint = (offer: OfferFragment | null | undefined) => {
  return offer?.constraints.find(constraintHelper.isPaymentMethod);
};

export const getPaymentMethodInitialValues = (
  offer: OfferFragment | null | undefined,
): PaymentMethodFormValues['paymentMethodConstraint'] => {
  const paymentMethodConstraint = getPaymentMethodConstraint(offer);
  const paymentInstruments = getPaymentInstrumentsInitialValues(offer);

  const isEnabled =
    paymentMethodConstraint &&
    paymentMethodConstraint.paymentEvaluationMethod === Payment_Method_Evaluation_Method.Include &&
    paymentMethodConstraint.paymentMethods.some(
      (method) => method === Activate_Payment_Method.MobileApp,
    );

  return {
    isEnabled: isEnabled || false,
    paymentInstruments,
  };
};

export const getPaymentMethodConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: PaymentMethodFormValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  const operations: Operation[] = [];

  if (
    !isFieldDirty<PaymentMethodFormValues>(dirtyFields, 'paymentMethodConstraint.isEnabled') &&
    !isFieldDirty<PaymentMethodFormValues>(
      dirtyFields,
      'paymentMethodConstraint.paymentInstruments',
    )
  ) {
    return [];
  }

  const existingPaymentMethodConstraint = getPaymentMethodConstraint(offer);
  const paymentInstrumentOperations = getPaymentInstrumentConstraintOperations(
    offerId,
    offer,
    values,
  );

  if (
    existingPaymentMethodConstraint &&
    existingPaymentMethodConstraint.paymentEvaluationMethod ===
      Payment_Method_Evaluation_Method.Include
  ) {
    operations.push(makeDeleteOperation('constraintDelete', existingPaymentMethodConstraint.id));
  }

  if (values.paymentMethodConstraint.isEnabled) {
    operations.push(
      makeCreatePaymentMethodConstraintOperation(
        offerId,
        Payment_Method_Evaluation_Method.Include,
        [Activate_Payment_Method.MobileApp],
      ),
    );
  }

  operations.push(...paymentInstrumentOperations);

  return operations;
};
